<template>
	<div class="block-with-icon">
		<slot name="icon" :icon="point.icon"><div :class="point.icon"></div></slot>
		<slot v-if="title" name="title" :text="point.title">
			<div class="sectionTitle" v-html="$sanitize(point.title)"></div>
		</slot>
		<slot name="text" :text="point.description">
			<div class="desc" v-html="$sanitize(point.description)"></div>
		</slot>
	</div>
</template>

<script>
import SanitizeMixin from '../../../mixins/buyout/sanitize';
export default {
	name: 'HowItWorksTile',
	mixins: [SanitizeMixin],
	props: {
		title: {
			type: Boolean
		},
		point: {
			type: Object,
			require: true
		}
	}
}
</script>
